import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import "../styles/Login.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import logo from "../assets/images/bgLogo.png";
import loginImage from "../assets/images/lbg.png";
import mobileImage from "../assets/images/lbg-mobile.png";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const disableContextMenu = (e) => e.preventDefault();
    const blockShortcuts = (e) => {
      if (
        e.ctrlKey &&
        ["u", "i", "j", "s", "h", "a"].includes(e.key.toLowerCase())
      ) {
        e.preventDefault();
      }
      if (e.key === "F12" || (e.ctrlKey && e.shiftKey && e.key === "I")) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", disableContextMenu);
    document.addEventListener("keydown", blockShortcuts);

    let devToolsOpen = false;

    const closePage = () => {
      if (devToolsOpen) {
        window.location.href = "about:blank";
        window.close();
        setTimeout(() => window.open("", "_self").close(), 100);
      }
    };

    const detectDevTools = () => {
      const element = new Image();
      element.__defineGetter__("id", function () {
        devToolsOpen = true;
        closePage();
      });
      console.log("%c", element);
    };
    detectDevTools();

    const devToolsCheck = setInterval(() => {
      const widthExceeded = window.outerWidth - window.innerWidth > 100;
      const heightExceeded = window.outerHeight - window.innerHeight > 100;
      if (widthExceeded || heightExceeded) {
        devToolsOpen = false;
        closePage();
      }
    }, 500);

    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
      window.history.pushState(null, "", window.location.href);
      if (devToolsOpen) window.location.reload();
    };

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        localStorage.setItem("leftPage", "true");
      } else if (localStorage.getItem("leftPage") === "true") {
        if (devToolsOpen) closePage();
        localStorage.removeItem("leftPage");
      }
    });

    return () => {
      clearInterval(devToolsCheck);
      document.removeEventListener("contextmenu", disableContextMenu);
      document.removeEventListener("keydown", blockShortcuts);
    };
  }, []);

  const routes = {
    admin: "/admin-dashboard",
    aruid: "/arms-dashboard",
    dsruid: "/dsr-dashboard",
    firuid: "/fir-dashboard",
    lduid: "/local-domicile-dashboard",
    lcuid: "/local-certificate-dashboard",
    pasuid: "/passport-dashboard",
    ccuid: "/complaints-cell",
    ecuid: "/certificates-dashboard",
    cquid: "/commissioner-qta-sdsr",
    acsuid: "/admin-hub-sdsr",
    prouid: "/e-property",
    tehsildar: "/tehsildar-dashboard",
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    // Test data (remove in production)
    const testCredentials = {
      username: "admin",
      password: "admin123" // Change this to actual test password
    };

    try {
      console.log("Attempting login with:", { username, password });
      
      // For testing: Try with hardcoded credentials first
      const testMode = false; // Set to true for testing
      let useUsername = username;
      let usePassword = password;
      
      if (testMode) {
        useUsername = testCredentials.username;
        usePassword = testCredentials.password;
        console.log("Using test credentials");
      }

      const response = await fetch("https://chaman.gob.pk/eac_backend/login.php", {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          username: useUsername, 
          password: usePassword 
        }),
      });

      console.log("Response status:", response.status);
      console.log("Response headers:", Object.fromEntries(response.headers.entries()));

      // Get response as text first
      const responseText = await response.text();
      console.log("Raw response:", responseText.substring(0, 500));

      // Try to parse JSON
      let data;
      try {
        data = JSON.parse(responseText);
        console.log("Parsed data:", data);
      } catch (parseError) {
        console.error("JSON parse error:", parseError);
        console.error("Response was:", responseText);
        throw new Error("Server returned invalid response. Check debug.log on server.");
      }

      if (data.success) {
        console.log("Login successful! Role:", data.role);
        const role = data.role;
        
        // Save user to context and localStorage
        setUser({ 
          username: useUsername, 
          role,
          menus: data.menus || []
        });
        
        // Navigate to appropriate route
        const route = routes[role];
        if (route) {
          console.log("Navigating to:", route);
          navigate(route);
        } else {
          console.error("No route defined for role:", role);
          setError(`No dashboard available for role: ${role}. Contact administrator.`);
        }
      } else {
        console.error("Login failed:", data.message);
        setError(data.message || "Invalid username or password");
      }
    } catch (error) {
      console.error("Login process error:", error);
      
      // User-friendly error messages
      if (error.message.includes("Failed to fetch") || 
          error.message.includes("NetworkError")) {
        setError("Cannot connect to server. Please check your internet connection.");
      } else if (error.message.includes("invalid response")) {
        setError("Server error. Please check the debug.log file on server.");
      } else {
        setError(error.message || "Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Left Section */}
        <div className="login-lft-section">
          <div className="login-content">
            <img src={logo} alt="Logo" className="login-logoleftside" />
            <h1 className="login-heading">E-ADMINISTRATION CHAMAN</h1>
            <p className="login-desc">
              Balochistan has lagged behind in digital governance compared to other provinces. However, the District Administration Chaman, under the supervision of Deputy Commissioner Chaman <strong>Habib Ahmed Bangulzai</strong>, took a significant step forward by introducing E-Administration Chaman.
            </p>
            <blockquote className="login-quote">
              <p>
                This application aims to provide timely information to the public regarding their applications and related documents, including the passport system, issuance of local certificates, and other essential services. Additionally, the E-system generates online Challans of FIRs.  E-Administration Chaman is a crucial step towards enhancing public service, increasing transparency, efficiency, and accountability in governance. The District Administration Chaman acknowledges the unwavering support of Speaker Balochistan Assembly, Capt (R) Abdul Khalique Khan Achakzai, for the completion of the E-Administration setup in his constituency.
              </p>
              <footer>
                <strong>Habib Ahmed Bangulzai | </strong>
                Deputy Commissioner Chaman
              </footer>
            </blockquote>
          </div>
          <img src={loginImage} alt="Login" className="login-image login-desktop-image" />
          <img src={mobileImage} alt="Mobile Login" className="login-image login-mobile-image" />
        </div>

        {/* Right Section */}
        <div className="login-rht-section">
          <h1>Welcome back</h1>
          <h4 className="login-styled-line">Please enter your login details</h4>
          {error && <h6 className="login-error-message">{error}</h6>}

          <form onSubmit={handleLogin}>
            <div className="login-entry">
              <div className="login-input-cont">
                <i className="fas fa-user"></i>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Username"
                  required
                  disabled={loading}
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="login-entry">
              <div className="login-input-cont">
                <i className="fas fa-lock"></i>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  required
                  disabled={loading}
                  autoComplete="current-password"
                />
                <span 
                  className="login-password-toggle" 
                  onClick={() => !loading && setShowPassword(!showPassword)}
                  style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
                >
                  <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                </span>
              </div>
            </div>

            <button 
              type="submit" 
              className="login-button"
              disabled={loading || !username || !password}
            >
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                  Logging in...
                </>
              ) : (
                "Login"
              )}
            </button>
            
            {/* Debug info */}
            <div style={{ 
              marginTop: '15px', 
              fontSize: '11px', 
              color: '#999',
              textAlign: 'center',
              borderTop: '1px solid #eee',
              paddingTop: '10px'
            }}>
              {/* <div>Endpoint: /eac_backend/login.php</div> */}
              <div style={{ marginTop: '5px', cursor: 'pointer' }} 
                   onClick={() => {
                     console.log("Current credentials:", { username, password });
                     alert("Check browser console for debug info");
                   }}>
                {/* Click here for debug info */}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;